/**
 * DOM utility functions for UI interactions
 */

/**
 * Scrolls the window to the top with smooth animation
 */
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

/**
 * Sends event data to the window dataLayer for analytics
 * @param {string} event - The event name
 * @param {string|Object} service - The service or data to track
 */
export const sendToWindowDataLayer = (event, service) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    clickText: service,
  });
};
